import { format } from "@react-input/mask";

export type MaskConfig = {
  mask: string;
  replacement?: Record<string, RegExp>;
  expectedLength: number;
};

export const buildMaskConfig = (mask?: string): MaskConfig => {
  if (!mask) {
    return { mask: "", replacement: undefined, expectedLength: 0 };
  }

  const displayMask = mask.replace(/[90]/g, "_");
  const hasDigits = /[90]/.test(mask);
  const replacement = hasDigits ? { _: /\d/ } : undefined;
  const expectedLength = hasDigits ? (displayMask.match(/_/g) || []).length : 0;

  return { mask: displayMask, replacement, expectedLength };
};

export const applyMask = (value: string, mask?: string): string => {
  if (!mask || !value) return value;

  const config = buildMaskConfig(mask);
  if (!config.replacement) return value;

  return format(value, {
    mask: config.mask,
    replacement: config.replacement,
  });
};
